export const normalizeSlug = (val: string) => {
  const parts = val
    .toLowerCase()
    .split('/')
    .filter(Boolean)
    .map(p =>
      p
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-{2,}/g, '-')
    )
    .filter(Boolean)

  return '/' + parts.join('/') + '/'
}

const isSlugStructureValid = (val: string) =>
  /^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*)(?:\/(?:[a-z0-9]+(?:-[a-z0-9]+)*))*\/$/.test(val)

const reservedPaths = ['/admin/']

const isSlugNotReserved = (val: string) =>
  reservedPaths.every(p => !val.startsWith(p))

export const isSlugValid = (val: string) => {
  return isSlugStructureValid(val) && isSlugNotReserved(val)
}
